var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"slider",staticClass:"slider"},[_c('div',{staticClass:"process",style:({width: _vm.width})}),_c('div',{ref:"trunk",staticClass:"thunk",style:({left: _vm.left})},[_c('div',{staticClass:"block"})])])}
var staticRenderFns = []

export { render, staticRenderFns }